import { ExportFileFormat } from '../export-task.enum';
import { ExportDocumentSection, ExportProcessorSectionOptions, ExportTaskProcessorContext } from '../export-task.interfaces';
import { types } from './types/processor-type';
import { Worksheet } from 'exceljs'; // 👈 importante importar de exceljs

export class ExportTaskProcessor {
  protected context: ExportTaskProcessorContext;
  readonly sections: ExportDocumentSection[] = [];
  private columnWidthsTracker: Map<string, number[]> = new Map();

  static get types() {
    return types;
  }

  /** @ignore */
  __init(context: ExportTaskProcessorContext) {
    this.context = context;
    this.onInit();
  }

  onInit(): void {}

  onAddData(data: any): void {
    if (typeof data === 'undefined' || data === null) return;
    if (Array.isArray(data)) {
      data.forEach((item) =>
        this.addToSection(
          this.context.format === ExportFileFormat.JSON ? null : this.context.title,
          item,
        ),
      );
    } else {
      this.addToSection(
        this.context.format === ExportFileFormat.JSON ? null : this.context.title,
        data,
      );
    }
  }

  createNewSection(
    name: string | null,
    title: string,
    options: ExportProcessorSectionOptions = {},
  ) {
    const section = { title, name, list: [], itemLocalization: {}, options };
    this.sections.push(section);
    if (name && options.columnWidths) {
      this.columnWidthsTracker.set(name, [...options.columnWidths]);
    }
    return section;
  }

  setSectionTitle(name: string | null, title: string) {
    let section = this.sections.find((fromSection) => fromSection.name === name);
    if (!section) section = this.createNewSection(name, title, {});
    section.title = title;
  }

  setSectionOptions(name: string | null, options: ExportProcessorSectionOptions) {
    let section = this.sections.find((fromSection) => fromSection.name === name);
    if (!section) section = this.createNewSection(name, name, options);
    section.options = {
      ...section.options,
      ...options,
    };
  }

  addToSection(name: string | null, item: any | any[]) {
    let section = this.sections.find((fromSection) => fromSection.name === name);
    if (!section) section = this.createNewSection(name, name, {});
    if (Array.isArray(item)) {
      section.list.push(...item);
    } else {
      section.list.push(item);
    }
  }

  localizeItemProperties(sectionName: string, properties: Record<string, string>) {
    let section = this.sections.find((fromSection) => fromSection.name === sectionName);
    if (!section) section = this.createNewSection(sectionName, sectionName, {});
    section.itemLocalization = { ...properties };
  }

} 